import React, { useEffect } from "react"
import { SideNavOsc } from "../../layout/SideNavOsc"
import LoggedTemplateProps from "../types/LoggedTemplate"
import SideNav from "./Sidenav"
const LoggedTemplate = ({
    isLogged,
    menuItems,
    children,
    userData,
    brandLogoUrl,
    pageTitle,
    headerContent,
    showHeader,
    bg_color,
    sideNavUserColor,
    sideNavUserTextColor,
    hoverColor,
    hoverText,
    textColor,
    contentContainerClassName: containerClasses
    }:LoggedTemplateProps ) => {

    useEffect( () => {
        document.title = pageTitle ?? 'Admin'
    }, [ pageTitle ] )

    return (
        <div className="h-screen w-screen flex bg-bg overflow-hidden">
            {bg_color === 'bg-primary' ? <SideNavOsc items={ menuItems } /> :
            <SideNav
                items={ menuItems }
                sideNavUserTextColor={sideNavUserTextColor}
                sideNavUserColor={sideNavUserColor}
                bg_color={bg_color}
                userData={ userData }
                brandLogoUrl={ brandLogoUrl }
                hoverColor={hoverColor}
                hoverText={hoverText}
                textColor={textColor}
            />}

            <div className="flex flex-1 flex-col overflow-x-auto">
                {
                    showHeader &&
                    <div className="w-full bg-white text-xl flex items-center p-4 font-bold">
                        { pageTitle }
                        { headerContent }
                    </div>
                }
                <div className={ "flex-1 w-full bg-bg-content overflow-x-hidden overflow-y-auto " + containerClasses }>
                    {
                        isLogged &&
                            <> { children } </>
                    }
                </div>
                <div className="w-full h-10 bg-white text-xs flex items-center justify-center">
                    powered by
                    <a className="flex ml-1" target='_blank' href="https://www.korbantech.com.br" rel="noreferrer">
                        @korbantech tecnologia
                    </a>
                </div>
            </div>
        </div>
    )
}

export default LoggedTemplate
